import {Badge} from "@cloudscape-design/components";

// TODO: This needs to be replace with something that has nicer interaction feel
export function ClickableBadge(props: { onClick: () => void, label: string, color: 'blue' | 'grey' | 'green' | 'red' }) {
    return <span className={"clickable"} onClick={props.onClick}>
        <Badge color={props.color}>{props.label}</Badge>
    </span>;
}